<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Проведение исследования</h1>
      </v-col>
    </v-row>
    <patient-header />
    <h2>ICL Med</h2>

    <div class="row">
      <div class="col-lg-9">
        <div v-if="!unitsTimetable.length" class="d-flex justify-center align-center">
          <Loader loading></Loader>
        </div>

        <div v-else class="d-flex">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th></th>
                </tr>
                <tr>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(schedule, idx) in schedules.values()" :key="`schedule-${idx}`" style="pointer-events: none;">
                  <td style="white-space: break-spaces; height: 40px;">{{ schedule.uiTime }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-simple-table v-for="unit in unitsTimetable" :key="`unit-${unit.id}`" dense class="w-100">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">{{ unit.name }}</th>
                </tr>
                <tr>
                  <th class="text-center">{{ currentDate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="schedule in unit.schedule.values()" :key="`${unit.id}-${schedule.data}`">
                  <td style="height: 40px;" class="text-center" @click="onSchedule(schedule, unit)">
                    <span v-if="schedule.item" class="v-chip theme--dark v-size--default bg-at-reception">
                      <span class="v-chip__content">
                        {{ schedule.item.patient.name }}
                      </span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="theme--light v-application v-expansion-panels mb-5 py-4 px-6">
          <div class="d-flex flex-column mr-auto w-100">
            <div class="d-flex justify-content-between align-center w-100 mb-2">
              <div class="h3 font-weight-bold">Дата расписания</div>
              <div class="d-flex justify-end flex-fill">
                <v-btn text plain small @click.prevent="resetFilter">Сбросить фильтры</v-btn>
              </div>
            </div>

            <div class="d-flex align-items-end">
              <DatePicker label="Выбор даты" hide-clear-btn v-model="date" @change="onDateChange" />
            </div>
          </div>
        </div>

        <v-expansion-panels class="mb-5">
          <v-expansion-panel>
            <v-expansion-panel-header>
              Ресурс
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="d-flex flex-column">
                <v-checkbox
                  v-for="unit in units"
                  :key="`unit-${unit.id}`"
                  :label="unit.name"
                  :value="unit.id"
                  v-model="selectedUnits"
                />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mb-5">
          <v-dialog max-width="1000px" v-model="addTaskDialog">
            <template v-slot:activator="{ on, attrs }">
              <v-btn block color="primary" dark v-bind="attrs" v-on="on">
                Назначить задание
                <v-icon right dark>add</v-icon>
              </v-btn>
            </template>

            <AddTask :units="units" :patients="patients" @submit="onAddTask" />
          </v-dialog>
        </div>

        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Легенда
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons">check_circle</span>
                  <span class="d-block pl-1">Нерабочий день</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons">check_circle</span>
                  <span class="d-block pl-1">Назначена запись на прием</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons">check_circle</span>
                  <span class="d-block pl-1">Запись на прием подтверждена</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons c-patient-not-found">check_circle</span>
                  <span class="d-block pl-1 ">Пациент не пришел</span>
                </div>
                <div class="d-flex align-items-center м">
                  <span class="d-block material-icons">check_circle</span>
                  <span class="d-block pl-1">Отказ во время приема</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons">check_circle</span>
                  <span class="d-block pl-1">Пациент в клинике</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons c-at-reception">check_circle</span>
                  <span class="d-block pl-1 ">Пациент на приеме</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons c-reception-completed">check_circle</span>
                  <span class="d-block pl-1">Приём завершен</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="d-block material-icons">check_circle</span>
                  <span class="d-block pl-1">Приём подписан</span>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />

    <v-row>
      <v-col lg="9">
        <div class="d-flex flex-column ">
          <h2>DicomHelper</h2>
          <p>DicomHelper должен быть запущен для проведения исследования</p>
        </div>
        <v-row>
          <v-col>
            <v-btn target="_blank" id="start-research-link" color="primary" href="dicomhelper://resid=314">
              Провести исследование
            </v-btn>
          </v-col>

          <v-col>
            <div class="d-flex w-100">
              <div class="ml-auto">
                <v-btn class="btn btn-default" target="_blank" href="/downloads/DicomHelperSetup-v-1.1.msi">
                  Скачать DicomHelper
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <iframe id="download_iframe" style="display:none;" src=""></iframe>
  </v-container>
</template>

<script>
import Modal from "@/components/Modal";
import { IclService } from "@/services/api/icl.service.js";
import AddTask from "@/views/pages/research/components/AddTask.vue";
import { groupBy } from "@/services/utils.js";
import Loader from "@/components/Loader.vue";
import ShowTask from "@/views/pages/research/components/ShowTask.vue";
import DatePicker from "@/components/forms/DatePicker.vue";
import PatientHeader from "@/components/PatientHeader";

export default {
  name: "Research",

  components: {
    DatePicker,
    Loader,
    AddTask,
    Modal,
    PatientHeader,
  },

  data() {
    return {
      date: this.$date().format("YYYY-MM-DD"),
      selectedUnits: [],
      menu: false,
      addTaskDialog: false,
      schedules: this.buildSchedule(),
      units: [],
      patients: [],
      timetable: [],
    };
  },

  computed: {
    patient() {
      return this.$store.state.customer.profile;
    },
    currentDate() {
      return this.$date(this.date).format("MMMM D, YYYY");
    },

    filteredUnits() {
      if (this.selectedUnits.length) {
        return this.units.filter(item => this.selectedUnits.includes(item.id));
      }

      return this.units;
    },

    unitsTimetable() {
      const data = [];
      const timetableGroupByUnit = groupBy("unit_id")(this.timetable);

      for (const unit of this.filteredUnits) {
        const scheduleItems = timetableGroupByUnit[unit.id] ? timetableGroupByUnit[unit.id] : [];
        const schedules = this.$date().isSame(this.date, "day") ? new Map(this.schedules) : this.buildSchedule();

        scheduleItems.forEach(item => {
          const key = this.$date(item.start_at).format("YYYY-MM-DD HH:mm");
          if (schedules.has(key)) {
            schedules.set(key, {
              ...schedules.get(key),
              item: {
                id: item.id,
                patient: {
                  id: item.patient.id,
                  name: `${item.patient.last_name} ${item.patient.first_name} ${item.patient.middle_name}`,
                },
              },
            });
          }
        });

        data.push({ ...unit, schedule: schedules });
      }

      return data;
    },
  },

  async created() {
    await this.loadReferences();
  },

  methods: {
    async loadReferences() {
      const [units, patients, timetable] = await Promise.all([
        await IclService.getUnits(),
        await IclService.getPatients(`${this.patient?.last_name} ${this.patient?.first_name} ${this.patient?.middle_name}`),
        await IclService.getTimetableByDate(this.date),
      ]);
      this.units = units;
      this.patients = patients;
      this.timetable = timetable;
    },

    async onDateChange() {
      this.timetable = await IclService.getTimetableByDate(this.date);
    },

    buildSchedule() {
      const schedules = new Map();
      const keyFormat = "YYYY-MM-DD HH:mm";

      let currentDate = this.$date(this.date)
        .startOf("day")
        .set("hour", 8)
        .set("second", 0);
      const endDate = currentDate.set("hour", 20).set("second", 0);

      schedules.set(currentDate.format(keyFormat), {
        data: currentDate.format(),
        time: currentDate.format("HH:mm"),
        uiTime: currentDate.get("minutes") === 0 ? currentDate.format("HH:mm") : currentDate.format(":mm"),
        item: null,
      });

      while (currentDate.isBefore(endDate)) {
        currentDate = currentDate.add(15, "minute");
        schedules.set(currentDate.format(keyFormat), {
          data: currentDate.format(),
          time: currentDate.format("HH:mm"),
          uiTime: currentDate.get("minutes") === 0 ? currentDate.format("HH:mm") : `    ` + currentDate.format(":mm"),
          item: null,
        });
      }

      return schedules;
    },

    resetFilter() {
      this.date = this.$date().format("YYYY-MM-DD");
      this.selectedUnits = [];
    },

    async onSchedule(schedule, unit) {
      if (schedule.item) {
        this.$dialog.show(ShowTask, { item: schedule.item, width: "1000px" });
        return;
      }

      const result = await this.$dialog.showAndWait(AddTask, {
        unit,
        schedule,
        patients: this.patients,
        width: "1000px",
        persistent: true,
      });
      if (result) {
        this.timetable.push(result);
      }
    },

    async onAddTask(task) {
      this.addTaskDialog = false;

      if (task) {
        this.timetable.push(task);
      }
    },
  },
};
</script>

<style scoped>
.launch-link {
  display: block;
  height: 0;
  width: 200px;
  overflow: hidden;
}

.v-data-table .bg-patient-not-found,
.bg-patient-not-found {
  background-color: #fe6666;
  border-color: #fe6666;
}

.c-patient-not-found {
  color: #fe6666;
}

.v-data-table .bg-reception-completed,
.bg-reception-completed {
  background-color: #376137;
  border-color: #376137;
}

.c-reception-completed {
  color: #376137;
}

.v-data-table .bg-at-reception,
.bg-at-reception {
  background-color: #51c351;
  border-color: #51c351;
}

.c-at-reception {
  color: #51c351;
}

.w-100 {
  width: 100%;
}

.v-chip .v-chip__content {
  font-size: 18px;
}

.phone-padding {
  padding-right: 40px;
}
</style>
